import { qrCodeComponent } from './qrCodeComponent';

export const qrCodePlugin = editor => {
  qrCodeComponent(editor);
};
